import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';

export default function useGetPagination() {
  const [searchParams] = useSearchParams();
  const sortByValue = searchParams.get('sortBy') || ''
  const orderByValue = searchParams.get('orderBy') || 'ASC'
  const pageValue = searchParams.get('page') || '1'
  const pageSizeValue = searchParams.get('pageSize') || '10'
  const searchFilterText = searchParams.get('searchText') || ''
  const [page, setPage] = useState(pageValue);
  const [pageSize, setPageSize] = useState(pageSizeValue);
  const [sortBy, setSortBy] = useState(sortByValue);
  const [orderBy, setOrderBy] = useState(orderByValue);
  const [searchText, setSearchText] = useState(searchFilterText);

  useEffect(() => {
    setSortBy(sortByValue);
    setOrderBy(orderByValue);
    setPage(pageValue);
    setPageSize(pageSizeValue);
    setSearchText(searchFilterText);
  }, [sortByValue, orderByValue, pageSizeValue, pageValue, searchFilterText])

  const handleUpdatePage = (page: string) => {
    setPage(page)
  }
  const handleUpdatePageSize = (pageSize: string) => {
    setPageSize(pageSize)
  }
  const handleUpdateSortBy = (sortBy: string) => {
    setSortBy(sortBy)
  }
  const handleUpdateOrderBy = (orderBy: string) => {
    setOrderBy(orderBy)
  }

  return { page, pageSize, sortBy, orderBy, handleUpdatePage, handleUpdatePageSize, handleUpdateSortBy, handleUpdateOrderBy, searchText }
}
